
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("D7PHQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $inPa6 = parcelRequire("inPa6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $2pBiX = parcelRequire("2pBiX");


var $4R3wx = parcelRequire("4R3wx");


var $8Q0mA = parcelRequire("8Q0mA");


var $6T0Pj = parcelRequire("6T0Pj");


var $gIaMn = parcelRequire("gIaMn");

var $jmjWc = parcelRequire("jmjWc");


var $5Abqh = parcelRequire("5Abqh");


const $98cee705389562e0$export$2a0b2901b6f1e4ac = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "TnkNJ",
    name: "LoomCrossFlowPopupLoader",
    loader: async ()=>(await (parcelRequire("jFlST"))).LoomCrossFlowPopupComponent,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).LoomButton
});

const $98cee705389562e0$export$ba53a8d423873260 = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "d4je0",
    name: "LoomCrossJoinPopupLoader",
    loader: async ()=>(await (parcelRequire("2ucFg"))).LoomCrossJoinPopupComponent,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).LoomButton
});



var $5i3ci = parcelRequire("5i3ci");


var $ma85v = parcelRequire("ma85v");


var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");














var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $1qfLF = parcelRequire("1qfLF");





var $3gadb = parcelRequire("3gadb");











var $9uAPw = parcelRequire("9uAPw");







var $gtD4K = parcelRequire("gtD4K");




var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $7hpmn = parcelRequire("7hpmn");


var $5RBJ9 = parcelRequire("5RBJ9");

var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");





var $hQYP3 = parcelRequire("hQYP3");

const $3ef7402a2084b243$var$i18n = (0, $cgtv4.defineMessages)({
    dismissButton: {
        id: "loom-onboarding.page-header-button-spotlight.dismissButton",
        defaultMessage: "Dismiss"
    },
    bodyGA: {
        id: "loom-onboarding.page-header-button-spotlight.ga-content",
        defaultMessage: "Record a Loom video to create a personal walkthrough of your content."
    },
    buttonTextGA: {
        id: "loom-onboarding.page-header-button-spotlight.ga-button-text",
        defaultMessage: "Record"
    }
});
const $3ef7402a2084b243$var$GA_SCREEN_NAME = 'pageHeaderLoomButtonGAOnboardingSpotlight';
// Backup outline in case we disable the spotlight pulse for a11y reasons (e.g. reduce motion)
const $3ef7402a2084b243$var$customAllyPulseStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.medium',
    // @ts-ignore
    boxShadow: `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`
});
const $3ef7402a2084b243$var$customAllyPulseStylesCircle = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    outline: `2px solid ${"var(--ds-border-discovery, #AF59E1)"}`
});
const $3ef7402a2084b243$export$4a188361cc0d166d = ({ children: children, onClose: onClose, onTryClick: onTryClick, isCircle: isCircle })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isClosed = (0, $42omo.useRef)(false);
    const close = (0, $42omo.useCallback)(()=>{
        if (!isClosed.current) {
            isClosed.current = true;
            onClose?.();
        }
    }, [
        onClose
    ]); // Call `onClose()` when this component unmounts if it wasn't already closed in order to catch when the spotlight
    // disappears if users click outside of it. This is important because we need the parent to know when to call `stop()`
    // for the EP message so we don't block other onboarding from appearing for 5 min (the default expiration time)
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            close();
        };
    }, [
        close
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: $3ef7402a2084b243$var$GA_SCREEN_NAME
            }
        }).fire(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: $3ef7402a2084b243$var$GA_SCREEN_NAME
            }
        }).fire();
        close();
    }, [
        close,
        createAnalyticsEvent
    ]);
    const handleTryItOut = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'record',
                source: $3ef7402a2084b243$var$GA_SCREEN_NAME
            }
        }).fire();
        onTryClick();
        close();
    }, [
        close,
        onTryClick,
        createAnalyticsEvent
    ]);
    const bodyMessage = $3ef7402a2084b243$var$i18n.bodyGA;
    const buttonText = $3ef7402a2084b243$var$i18n.buttonTextGA;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "page-header-loom-button-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $3ef7402a2084b243$var$customAllyPulseStyles,
            isCircle && $3ef7402a2084b243$var$customAllyPulseStylesCircle
        ]
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
        target: "page-header-loom-button-spotlight",
        targetBgColor: "var(--ds-text-inverse, #FFFFFF)",
        pulse: !isReducedMotion,
        targetRadius: isCircle ? 24 : 6,
        shouldWatchTarget: true,
        dialogWidth: 275,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($hQYP3))),
        actions: [
            {
                text: intl.formatMessage(buttonText),
                onClick: handleTryItOut
            },
            {
                text: intl.formatMessage($3ef7402a2084b243$var$i18n.dismissButton),
                onClick: handleDismiss,
                appearance: 'subtle'
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), bodyMessage))));
};



var $8fj5s = parcelRequire("8fj5s");


var $39rFu = parcelRequire("39rFu");


var $iXzFq = parcelRequire("iXzFq");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $bQm3c = parcelRequire("bQm3c");





var $ikPi2 = parcelRequire("ikPi2");





var $531iT = parcelRequire("531iT");

var $5f1bcad77068d6e7$export$8bfaa5cd7df1dbf0 = /*#__PURE__*/ function(PostLoomRecordingCTA) {
    PostLoomRecordingCTA["EDITOR_INSERT"] = "editorInsert";
    PostLoomRecordingCTA["PAGE_COMMENT_INSERT"] = "pageCommentInsert";
    PostLoomRecordingCTA["COPY_LINK"] = "copyLink";
    PostLoomRecordingCTA["OPEN_ON_LOOM"] = "openOnLoom";
    return PostLoomRecordingCTA;
}({})// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
;
const $5f1bcad77068d6e7$var$ButtonSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1ul91ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1ul91ul9",
            __cmplp.className
        ])
    });
});
const $5f1bcad77068d6e7$var$PageHeaderLoomButtonComponent = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(54);
    const { contentId: contentId, dataVC: dataVC, label: label, spaceKey: spaceKey, contentType: contentType, flags: flags, ssrPlaceholderIdProp: ssrPlaceholderIdProp, isCircle: t1, testId: testId, source: t2, isDisabled: t3 } = t0;
    const isCircle = t1 === undefined ? false : t1;
    const source = t2 === undefined ? "pageHeader" : t2;
    const isDisabled = t3 === undefined ? false : t3;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const [, loomInsertUrlActions] = (0, $ikPi2.useLoomInsertUrlState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let t4;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== loadEditor || $[3] !== loomInsertUrlActions || $[4] !== spaceKey) {
        t4 = (video)=>{
            loomInsertUrlActions.updateFullPageEditorLoomUrl(video);
            const redirectUrl = (0, $iXzFq.getUrlForContentType)({
                contentType: contentType,
                spaceKey: spaceKey,
                contentId: contentId,
                redirectToEditor: true
            });
            loadEditor({
                contentId: contentId,
                spaceKey: spaceKey,
                redirectUrl: redirectUrl,
                contentType: contentType
            });
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = loadEditor;
        $[3] = loomInsertUrlActions;
        $[4] = spaceKey;
        $[5] = t4;
    } else t4 = $[5];
    const saveLoomUrlAndLoadEditor = t4;
    let t5;
    if ($[6] !== experienceTracker) {
        t5 = (postLoomRecordingCTA)=>{
            experienceTracker.start({
                name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
                timeout: (0, $aJPUt.ExperienceTimeout).LOOM_PAGE_HEADER_CONTENT_INSERTION,
                attributes: {
                    postLoomRecordingCTA: postLoomRecordingCTA
                }
            });
        };
        $[6] = experienceTracker;
        $[7] = t5;
    } else t5 = $[7];
    const beginExperienceTracker = t5;
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $eSUdr.default)`query PageHeaderLoomButtonQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}content(id:$contentId status:["current" "draft"]){nodes{id operations{operation targetType}history{ownedBy{...on KnownUser{accountId}}}}}}`;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== contentId) {
        t7 = {
            variables: {
                contentId: contentId
            }
        };
        $[9] = contentId;
        $[10] = t7;
    } else t7 = $[10];
    const { data: data } = (0, $xQxzY.useQuery)(t6, t7);
    let openLoomRecorderParams;
    let postLoomRecordingCTA_0;
    let resetInsertFunctionOnUnmount;
    if ($[11] !== beginExperienceTracker || $[12] !== contentType || $[13] !== data?.content?.nodes?.[0] || $[14] !== data?.contentContributors?.isCurrentUserContributor || $[15] !== loomInsertUrlActions || $[16] !== saveLoomUrlAndLoadEditor || $[17] !== userId) {
        postLoomRecordingCTA_0 = "openOnLoom";
        resetInsertFunctionOnUnmount = false;
        const contentData = data?.content?.nodes?.[0];
        const isContentContributor = data?.contentContributors?.isCurrentUserContributor || contentData?.history?.ownedBy?.accountId === userId;
        const canEdit = contentData?.operations?.some((operation)=>operation?.operation === "update" && operation?.targetType === contentType);
        const canComment = contentData?.operations?.some($5f1bcad77068d6e7$var$_temp);
        if (canEdit && isContentContributor && contentType !== "database") {
            postLoomRecordingCTA_0 = "editorInsert";
            openLoomRecorderParams = {
                onInsert: (_, video_0)=>{
                    beginExperienceTracker(postLoomRecordingCTA_0);
                    saveLoomUrlAndLoadEditor(video_0);
                },
                insertButtonText: "Insert Loom video"
            };
        } else if (canComment && contentType !== "database") {
            postLoomRecordingCTA_0 = "pageCommentInsert";
            resetInsertFunctionOnUnmount = true;
            openLoomRecorderParams = {
                onInsert: (__0, video_1)=>{
                    beginExperienceTracker(postLoomRecordingCTA_0);
                    loomInsertUrlActions.updatePageCommentEditorLoomUrl(video_1);
                    const openPageCommentEditorButton = document.getElementById("addCommentButton");
                    openPageCommentEditorButton && openPageCommentEditorButton.click();
                },
                insertButtonText: "Add to comment"
            };
        } else postLoomRecordingCTA_0 = "copyLink";
        $[11] = beginExperienceTracker;
        $[12] = contentType;
        $[13] = data?.content?.nodes?.[0];
        $[14] = data?.contentContributors?.isCurrentUserContributor;
        $[15] = loomInsertUrlActions;
        $[16] = saveLoomUrlAndLoadEditor;
        $[17] = userId;
        $[18] = openLoomRecorderParams;
        $[19] = postLoomRecordingCTA_0;
        $[20] = resetInsertFunctionOnUnmount;
    } else {
        openLoomRecorderParams = $[18];
        postLoomRecordingCTA_0 = $[19];
        resetInsertFunctionOnUnmount = $[20];
    }
    let t8;
    if ($[21] !== flags || $[22] !== resetInsertFunctionOnUnmount) {
        t8 = {
            entryPointLocation: "pageHeader",
            flags: flags,
            resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount
        };
        $[21] = flags;
        $[22] = resetInsertFunctionOnUnmount;
        $[23] = t8;
    } else t8 = $[23];
    const { openLoomRecorder: openLoomRecorder, isOpeningRecorder: isOpeningRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, hasRecordingAccess: hasRecordingAccess } = (0, $9uAPw.useLoomRecorderEntryPoint)(t8);
    const shouldActivateLoomGAOnboarding = entryPointVariant === "CO_USE" && hasRecordingAccess && isLoomRecorderInitialized;
    let t9;
    if ($[24] !== shouldActivateLoomGAOnboarding) {
        t9 = shouldActivateLoomGAOnboarding && (0, $9wGTI.fg)("confluence_m25_onboarding_spotlights");
        $[24] = shouldActivateLoomGAOnboarding;
        $[25] = t9;
    } else t9 = $[25];
    const [isLoomGAOnboardingActive, stopLoomGAOnboarding] = (0, $8fj5s.useSkippableCoordination)("cc-loom-onboarding-spotlight-editor", !t9);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t10;
    if ($[26] !== contentType || $[27] !== createAnalyticsEvent || $[28] !== openLoomRecorder || $[29] !== openLoomRecorderParams || $[30] !== pageMode || $[31] !== postLoomRecordingCTA_0 || $[32] !== source) {
        t10 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "createLoomHeaderItem",
                    source: source,
                    attributes: {
                        postLoomRecordingCTA: postLoomRecordingCTA_0,
                        contentType: contentType,
                        pageMode: pageMode
                    }
                }
            }).fire();
            openLoomRecorder(openLoomRecorderParams);
        };
        $[26] = contentType;
        $[27] = createAnalyticsEvent;
        $[28] = openLoomRecorder;
        $[29] = openLoomRecorderParams;
        $[30] = pageMode;
        $[31] = postLoomRecordingCTA_0;
        $[32] = source;
        $[33] = t10;
    } else t10 = $[33];
    openLoomRecorderParams;
    postLoomRecordingCTA_0;
    const handleClick = t10;
    let t11;
    if ($[34] !== isLoomGAOnboardingActive || $[35] !== stopLoomGAOnboarding) {
        t11 = ()=>{
            if (isLoomGAOnboardingActive) stopLoomGAOnboarding();
        };
        $[34] = isLoomGAOnboardingActive;
        $[35] = stopLoomGAOnboarding;
        $[36] = t11;
    } else t11 = $[36];
    const handleSpotlightClose = t11;
    let t12;
    if ($[37] !== dataVC || $[38] !== handleClick || $[39] !== isCircle || $[40] !== isDisabled || $[41] !== isOpeningRecorder || $[42] !== label || $[43] !== ssrPlaceholderIdProp || $[44] !== testId) {
        t12 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5f1bcad77068d6e7$var$ButtonSpacer, null, isCircle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                label: label,
                ...tooltipProps,
                isLoading: isOpeningRecorder,
                onClick: handleClick,
                appearance: "subtle",
                shape: "circle",
                icon: (0, $531iT.LoomVideoIcon),
                testId: testId,
                isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, $531iT.LoomVideoIcon),
                label: label,
                ...tooltipProps,
                onClick: handleClick,
                isLoading: isOpeningRecorder,
                "data-vc": dataVC,
                ...ssrPlaceholderIdProp,
                testId: testId,
                isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
            }));
        $[37] = dataVC;
        $[38] = handleClick;
        $[39] = isCircle;
        $[40] = isDisabled;
        $[41] = isOpeningRecorder;
        $[42] = label;
        $[43] = ssrPlaceholderIdProp;
        $[44] = testId;
        $[45] = t12;
    } else t12 = $[45];
    let t13;
    if ($[46] !== label || $[47] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: label,
            position: "left"
        }, t12);
        $[46] = label;
        $[47] = t12;
        $[48] = t13;
    } else t13 = $[48];
    const baseLoomButton = t13;
    if (isLoomGAOnboardingActive && entryPointVariant === "CO_USE" && (0, $9wGTI.fg)("confluence_m25_onboarding_spotlights")) {
        let t14;
        if ($[49] !== baseLoomButton || $[50] !== handleClick || $[51] !== handleSpotlightClose || $[52] !== isCircle) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ef7402a2084b243$export$4a188361cc0d166d), {
                onTryClick: handleClick,
                onClose: handleSpotlightClose,
                isCircle: isCircle
            }, baseLoomButton);
            $[49] = baseLoomButton;
            $[50] = handleClick;
            $[51] = handleSpotlightClose;
            $[52] = isCircle;
            $[53] = t14;
        } else t14 = $[53];
        return t14;
    }
    return baseLoomButton;
} : ({ contentId: contentId, dataVC: dataVC, label: label, spaceKey: spaceKey, contentType: contentType, flags: flags, ssrPlaceholderIdProp: ssrPlaceholderIdProp, isCircle: isCircle = false, testId: testId, source: source = 'pageHeader', isDisabled: isDisabled = false })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, loomInsertUrlActions] = (0, $ikPi2.useLoomInsertUrlState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const saveLoomUrlAndLoadEditor = (video)=>{
        loomInsertUrlActions.updateFullPageEditorLoomUrl(video);
        const redirectUrl = (0, $iXzFq.getUrlForContentType)({
            contentType: contentType,
            spaceKey: spaceKey,
            contentId: contentId,
            redirectToEditor: true
        });
        loadEditor({
            contentId: contentId,
            spaceKey: spaceKey,
            redirectUrl: redirectUrl,
            contentType: contentType
        });
    };
    const beginExperienceTracker = (postLoomRecordingCTA)=>{
        experienceTracker.start({
            name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
            timeout: (0, $aJPUt.ExperienceTimeout).LOOM_PAGE_HEADER_CONTENT_INSERTION,
            attributes: {
                postLoomRecordingCTA: postLoomRecordingCTA
            }
        });
    };
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const { data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query PageHeaderLoomButtonQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}content(id:$contentId status:["current" "draft"]){nodes{id operations{operation targetType}history{ownedBy{...on KnownUser{accountId}}}}}}`, {
        variables: {
            contentId: contentId
        }
    });
    let openLoomRecorderParams;
    let postLoomRecordingCTA_0 = "openOnLoom";
    let resetInsertFunctionOnUnmount = false;
    const contentData = data?.content?.nodes?.[0];
    const isContentContributor = data?.contentContributors?.isCurrentUserContributor || // isCurrentUserContributor is false for unpublished drafts, so we also check the owner
    contentData?.history?.ownedBy?.accountId === userId;
    const canEdit = contentData?.operations?.some((operation)=>operation?.operation === 'update' && operation?.targetType === contentType);
    const canComment = contentData?.operations?.some((operation_0)=>operation_0?.targetType === 'comment' && operation_0?.operation === 'create');
    if (canEdit && isContentContributor && contentType !== 'database') {
        // editor mode insert
        postLoomRecordingCTA_0 = "editorInsert";
        openLoomRecorderParams = {
            onInsert: (_, video_0)=>{
                beginExperienceTracker(postLoomRecordingCTA_0);
                saveLoomUrlAndLoadEditor(video_0);
            },
            // intentionally not localized because Loom RecordSDK does not support i18n
            insertButtonText: 'Insert Loom video'
        };
    } else if (canComment && contentType !== 'database') {
        // page comment insert
        postLoomRecordingCTA_0 = "pageCommentInsert"; // Set to true so that CTA 'Add to comment' will not render if user has navigated to
        // different page post Loom recording.
        resetInsertFunctionOnUnmount = true;
        openLoomRecorderParams = {
            onInsert: (__0, video_1)=>{
                beginExperienceTracker(postLoomRecordingCTA_0);
                loomInsertUrlActions.updatePageCommentEditorLoomUrl(video_1);
                const openPageCommentEditorButton = document.getElementById('addCommentButton');
                openPageCommentEditorButton && openPageCommentEditorButton.click();
            },
            // intentionally not localized because Loom RecordSDK does not support i18n
            insertButtonText: 'Add to comment'
        };
    } else postLoomRecordingCTA_0 = "copyLink"; // Not defining openLoomRecorderParams here so that
    const { openLoomRecorder: openLoomRecorder, isOpeningRecorder: isOpeningRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, hasRecordingAccess: hasRecordingAccess } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        entryPointLocation: 'pageHeader',
        flags: flags,
        resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount
    });
    const shouldActivateLoomGAOnboarding = entryPointVariant === 'CO_USE' && hasRecordingAccess && isLoomRecorderInitialized;
    const [isLoomGAOnboardingActive, stopLoomGAOnboarding] = (0, $8fj5s.useSkippableCoordination)('cc-loom-onboarding-spotlight-editor', !(shouldActivateLoomGAOnboarding && (0, $9wGTI.fg)('confluence_m25_onboarding_spotlights')));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createLoomHeaderItem',
                source: source,
                attributes: {
                    postLoomRecordingCTA: postLoomRecordingCTA_0,
                    contentType: contentType,
                    pageMode: pageMode
                }
            }
        }).fire();
        openLoomRecorder(openLoomRecorderParams);
    }, [
        createAnalyticsEvent,
        openLoomRecorder,
        openLoomRecorderParams,
        postLoomRecordingCTA_0,
        source,
        pageMode,
        contentType
    ]);
    const handleSpotlightClose = (0, $42omo.useCallback)(()=>{
        if (isLoomGAOnboardingActive) stopLoomGAOnboarding();
    }, [
        stopLoomGAOnboarding,
        isLoomGAOnboardingActive
    ]);
    const baseLoomButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: label,
        position: "left"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5f1bcad77068d6e7$var$ButtonSpacer, null, isCircle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            label: label,
            ...tooltipProps,
            isLoading: isOpeningRecorder,
            onClick: handleClick,
            appearance: "subtle",
            shape: "circle",
            icon: (0, $531iT.LoomVideoIcon),
            testId: testId,
            isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, $531iT.LoomVideoIcon),
            label: label,
            ...tooltipProps,
            onClick: handleClick,
            isLoading: isOpeningRecorder,
            "data-vc": dataVC,
            ...ssrPlaceholderIdProp,
            testId: testId,
            isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
        })));
    if (isLoomGAOnboardingActive && entryPointVariant === 'CO_USE' && (0, $9wGTI.fg)('confluence_m25_onboarding_spotlights')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ef7402a2084b243$export$4a188361cc0d166d), {
        onTryClick: handleClick,
        onClose: handleSpotlightClose,
        isCircle: isCircle
    }, baseLoomButton);
    return baseLoomButton;
};
const $5f1bcad77068d6e7$export$eabaf9dbc33f86dd = (0, $7aRa9.withFlags)($5f1bcad77068d6e7$var$PageHeaderLoomButtonComponent);
function $5f1bcad77068d6e7$var$_temp(operation_0) {
    return operation_0?.targetType === "comment" && operation_0?.operation === "create";
}






var $cxQ7E = parcelRequire("cxQ7E");

/**
 * This touchpoint was previously in the page header, but has now been moved to the comments sidebar.
 * The naming will remain the same to avoid breaking any existing usages of this name.
 */ const $981c6be93b35769c$var$ENTRYPOINT_ID = 'loom-confluence-page-header';
const $981c6be93b35769c$var$SOURCE_COMPONENT = 'loomConfluencePageHeader';
const $981c6be93b35769c$var$SOURCE_CONTEXT = 'confluencePageHeaderRecordAVideo';
const $981c6be93b35769c$var$i18n = (0, $cgtv4.defineMessages)({
    crossJoinEntryPointLabel: {
        id: "page-header-loom-button.crossJoinEntryPointLabel",
        defaultMessage: "Join your team on Loom to record a video"
    },
    crossSellPopupCardDescription: {
        id: "page-header-loom-button.crossSellPopupCardDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossSellPopupCardTitle: {
        id: "page-header-loom-button.crossSellPopupCardTitle",
        defaultMessage: "Share your work with a video"
    },
    entryPointLabel: {
        id: "page-header-loom-button.entryPointLabel",
        defaultMessage: "Record a Loom video"
    }
});
const $981c6be93b35769c$var$ButtonSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1ul91ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1ul91ul9",
            __cmplp.className
        ])
    });
});
const $981c6be93b35769c$var$PageHeaderLoomEntryPointComponent = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(87);
    const { contentId: contentId, crossSellPopupPlacement: crossSellPopupPlacement, crossSellSpotlightPlacement: crossSellSpotlightPlacement, spaceKey: spaceKey, contentType: contentType, flags: flags, isCircle: t1, testId: testId, source: source, isDisabled: t2 } = t0;
    const isCircle = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let entryPointVariant;
    let error;
    let loading;
    if (window.__SSR_RENDERED__ && window.__SSR_LOOM_ENTRY_POINT__) entryPointVariant = window.__SSR_LOOM_ENTRY_POINT__.entryPointVariant;
    const entryPointFromState = (0, $4R3wx.useLoomEntryPointVariant)();
    entryPointVariant = entryPointFromState.entryPointVariant;
    error = entryPointFromState.error;
    loading = entryPointFromState.loading;
    const isEntryPointEnabled = [
        "BETA",
        "CO_USE",
        "CROSS_FLOW",
        "CROSS_JOIN",
        "NONE"
    ].includes(entryPointVariant);
    const { isPulseActive: isPulseActive } = (0, $ma85v.useDiscoverabilityPulsePostOffice)($981c6be93b35769c$var$ENTRYPOINT_ID);
    const intl = (0, $8C5kA.default)();
    let t3;
    if ($[0] !== flags) {
        t3 = {
            flags: flags
        };
        $[0] = flags;
        $[1] = t3;
    } else t3 = $[1];
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)(t3);
    let t4;
    if ($[2] !== createAnalyticsEvent || $[3] !== entryPointVariant) {
        t4 = ()=>{
            if (entryPointVariant === "CROSS_JOIN") createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    action: "viewed",
                    name: "createLoomHeaderItem",
                    attributes: {
                        adType: "crossJoin",
                        entrypoint: $981c6be93b35769c$var$ENTRYPOINT_ID,
                        sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = entryPointVariant;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== createAnalyticsEvent || $[6] !== entryPointVariant) {
        t5 = [
            createAnalyticsEvent,
            entryPointVariant
        ];
        $[5] = createAnalyticsEvent;
        $[6] = entryPointVariant;
        $[7] = t5;
    } else t5 = $[7];
    (0, $42omo.useEffect)(t4, t5);
    if (!isEntryPointEnabled) return null;
    if (entryPointVariant === "BETA" || entryPointVariant === "CO_USE") {
        let t6;
        if ($[8] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
            $[8] = intl;
            $[9] = t6;
        } else t6 = $[9];
        let t7;
        if ($[10] !== isDisabled) {
            t7 = isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false);
            $[10] = isDisabled;
            $[11] = t7;
        } else t7 = $[11];
        let t8;
        if ($[12] !== contentId || $[13] !== contentType || $[14] !== isCircle || $[15] !== source || $[16] !== spaceKey || $[17] !== ssrPlaceholderIdProp || $[18] !== t6 || $[19] !== t7 || $[20] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f1bcad77068d6e7$export$eabaf9dbc33f86dd), {
                contentId: contentId,
                contentType: contentType,
                dataVC: "loom-button",
                label: t6,
                spaceKey: spaceKey,
                ssrPlaceholderIdProp: ssrPlaceholderIdProp,
                isCircle: isCircle,
                testId: testId,
                source: source,
                isDisabled: t7
            });
            $[12] = contentId;
            $[13] = contentType;
            $[14] = isCircle;
            $[15] = source;
            $[16] = spaceKey;
            $[17] = ssrPlaceholderIdProp;
            $[18] = t6;
            $[19] = t7;
            $[20] = testId;
            $[21] = t8;
        } else t8 = $[21];
        return t8;
    }
    if (error) {
        let t6;
        if ($[22] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
            $[22] = intl;
            $[23] = t6;
        } else t6 = $[23];
        let t7;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            });
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== loomEntryPointErrorCallback || $[26] !== t6) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "subtle",
                "aria-label": t6,
                "data-vc": "loom-button",
                iconAfter: t7,
                onClick: loomEntryPointErrorCallback
            });
            $[25] = loomEntryPointErrorCallback;
            $[26] = t6;
            $[27] = t8;
        } else t8 = $[27];
        return t8;
    }
    if (loading) {
        let t6;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null);
            $[28] = t6;
        } else t6 = $[28];
        return t6;
    }
    if (entryPointVariant === "CROSS_FLOW") {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("confluence_selection_hydration_loom_button", "isEnabled", false)) {
            let t6;
            if ($[29] !== intl) {
                t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
                $[29] = intl;
                $[30] = t6;
            } else t6 = $[30];
            let t7;
            if ($[31] !== intl) {
                t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
                $[31] = intl;
                $[32] = t7;
            } else t7 = $[32];
            let t8;
            if ($[33] !== intl) {
                t8 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
                $[33] = intl;
                $[34] = t8;
            } else t8 = $[34];
            let t9;
            if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[35] = t9;
            } else t9 = $[35];
            let t10;
            if ($[36] !== crossSellPopupPlacement || $[37] !== crossSellSpotlightPlacement || $[38] !== isCircle || $[39] !== isPulseActive || $[40] !== t6 || $[41] !== t7 || $[42] !== t8) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98cee705389562e0$export$2a0b2901b6f1e4ac), {
                    description: t6,
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    placement: crossSellPopupPlacement,
                    spotlightPlacement: crossSellSpotlightPlacement,
                    sourceActionSubjectId: "createLoomHeaderItem",
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
                    sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
                    title: t7,
                    isCircle: isCircle,
                    ariaLabel: t8,
                    iconAfter: t9,
                    appearance: "subtle",
                    immediateActivationCondition: isPulseActive
                });
                $[36] = crossSellPopupPlacement;
                $[37] = crossSellSpotlightPlacement;
                $[38] = isCircle;
                $[39] = isPulseActive;
                $[40] = t6;
                $[41] = t7;
                $[42] = t8;
                $[43] = t10;
            } else t10 = $[43];
            return t10;
        }
        let t6;
        if ($[44] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
            $[44] = intl;
            $[45] = t6;
        } else t6 = $[45];
        let t7;
        if ($[46] !== intl) {
            t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
            $[46] = intl;
            $[47] = t7;
        } else t7 = $[47];
        let t8;
        if ($[48] !== intl || $[49] !== isCircle || $[50] !== ssrPlaceholderIdProp) {
            t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    ...triggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel),
                    "data-vc": "loom-button",
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    ...ssrPlaceholderIdProp
                })));
            $[48] = intl;
            $[49] = isCircle;
            $[50] = ssrPlaceholderIdProp;
            $[51] = t8;
        } else t8 = $[51];
        let t9;
        if ($[52] !== crossSellPopupPlacement || $[53] !== crossSellSpotlightPlacement || $[54] !== t6 || $[55] !== t7 || $[56] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T0Pj.LoomCrossFlowPopupCard), {
                description: t6,
                entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                placement: crossSellPopupPlacement,
                spotlightPlacement: crossSellSpotlightPlacement,
                sourceActionSubjectId: "createLoomHeaderItem",
                sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
                sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
                title: t7,
                trigger: t8
            });
            $[52] = crossSellPopupPlacement;
            $[53] = crossSellSpotlightPlacement;
            $[54] = t6;
            $[55] = t7;
            $[56] = t8;
            $[57] = t9;
        } else t9 = $[57];
        return t9;
    }
    if (entryPointVariant === "CROSS_JOIN") {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("confluence_selection_hydration_loom_button", "isEnabled", false)) {
            let t6;
            if ($[58] !== intl) {
                t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
                $[58] = intl;
                $[59] = t6;
            } else t6 = $[59];
            let t7;
            if ($[60] !== intl) {
                t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
                $[60] = intl;
                $[61] = t7;
            } else t7 = $[61];
            let t8;
            if ($[62] !== intl) {
                t8 = intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel);
                $[62] = intl;
                $[63] = t8;
            } else t8 = $[63];
            let t9;
            if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[64] = t9;
            } else t9 = $[64];
            const t10 = (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? flags : undefined;
            let t11;
            if ($[65] !== crossSellPopupPlacement || $[66] !== isCircle || $[67] !== isPulseActive || $[68] !== t10 || $[69] !== t6 || $[70] !== t7 || $[71] !== t8) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98cee705389562e0$export$ba53a8d423873260), {
                    description: t6,
                    placement: crossSellPopupPlacement,
                    sourceActionSubjectId: "createLoomHeaderItem",
                    title: t7,
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle,
                    ariaLabel: t8,
                    iconAfter: t9,
                    appearance: "subtle",
                    immediateActivationCondition: isPulseActive,
                    flags: t10,
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                });
                $[65] = crossSellPopupPlacement;
                $[66] = isCircle;
                $[67] = isPulseActive;
                $[68] = t10;
                $[69] = t6;
                $[70] = t7;
                $[71] = t8;
                $[72] = t11;
            } else t11 = $[72];
            return t11;
        }
        let t6;
        if ($[73] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
            $[73] = intl;
            $[74] = t6;
        } else t6 = $[74];
        let t7;
        if ($[75] !== intl) {
            t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
            $[75] = intl;
            $[76] = t7;
        } else t7 = $[76];
        let t8;
        if ($[77] !== intl || $[78] !== isCircle || $[79] !== ssrPlaceholderIdProp) {
            t8 = (href, t9)=>{
                const { onClick: onClick, ...otherTriggerProps } = t9;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    ...otherTriggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel),
                    "data-vc": "loom-button",
                    href: href,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    rel: "noreferrer",
                    target: "_blank",
                    onClick: onClick,
                    ...ssrPlaceholderIdProp
                })));
            };
            $[77] = intl;
            $[78] = isCircle;
            $[79] = ssrPlaceholderIdProp;
            $[80] = t8;
        } else t8 = $[80];
        const t9 = (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? flags : undefined;
        let t10;
        if ($[81] !== crossSellPopupPlacement || $[82] !== t6 || $[83] !== t7 || $[84] !== t8 || $[85] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
                description: t6,
                placement: crossSellPopupPlacement,
                sourceActionSubjectId: "createLoomHeaderItem",
                title: t7,
                entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                triggerLink: t8,
                flags: t9,
                sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
            });
            $[81] = crossSellPopupPlacement;
            $[82] = t6;
            $[83] = t7;
            $[84] = t8;
            $[85] = t9;
            $[86] = t10;
        } else t10 = $[86];
        return t10;
    }
    return null;
} : ({ contentId: contentId, crossSellPopupPlacement: crossSellPopupPlacement, crossSellSpotlightPlacement: crossSellSpotlightPlacement, spaceKey: spaceKey, contentType: contentType, flags: flags, isCircle: isCircle = false, testId: testId, source: source, isDisabled: isDisabled = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let entryPointVariant, error, loading; // if page is SSRd and the entry point variant was successfully preloaded during SSR
    // use the results from the window object
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (window.__SSR_RENDERED__ && window.__SSR_LOOM_ENTRY_POINT__) {
        entryPointVariant = window.__SSR_LOOM_ENTRY_POINT__.entryPointVariant;
        error = window.__SSR_LOOM_ENTRY_POINT__.error;
        loading = window.__SSR_LOOM_ENTRY_POINT__.loading;
    } // this hook will automatically return the preloaded entry point variant if it exists
    // however, this check will still occur for transitions/non-SSRd pages
    const entryPointFromState = (0, $4R3wx.useLoomEntryPointVariant)();
    entryPointVariant = entryPointFromState.entryPointVariant;
    error = entryPointFromState.error;
    loading = entryPointFromState.loading; /**
                                         * NONE being included here is to address a layout shift issue within the PageHeader while
                                         * the entrypoint is loading. If we don't include NONE here, while a page is loading
                                         * nothing will show where the entrypoint is, and then on load the entrypoint will pop in
                                         * and shift the buttons next to it to the left.
                                         */ 
    const isEntryPointEnabled = [
        'BETA',
        'CO_USE',
        'CROSS_FLOW',
        'CROSS_JOIN',
        'NONE'
    ].includes(entryPointVariant);
    const { isPulseActive: isPulseActive } = (0, $ma85v.useDiscoverabilityPulsePostOffice)($981c6be93b35769c$var$ENTRYPOINT_ID);
    const intl = (0, $8C5kA.default)();
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)({
        flags: flags
    });
    (0, $42omo.useEffect)(()=>{
        if (entryPointVariant === 'CROSS_JOIN') createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                action: 'viewed',
                name: 'createLoomHeaderItem',
                attributes: {
                    adType: 'crossJoin',
                    entrypoint: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointVariant
    ]);
    if (!isEntryPointEnabled) return null;
    if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f1bcad77068d6e7$export$eabaf9dbc33f86dd), {
        contentId: contentId,
        contentType: contentType,
        dataVC: "loom-button",
        label: intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel),
        spaceKey: spaceKey,
        ssrPlaceholderIdProp: ssrPlaceholderIdProp,
        isCircle: isCircle,
        testId: testId,
        source: source,
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel),
        "data-vc": "loom-button",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }),
        onClick: loomEntryPointErrorCallback
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null);
    if (entryPointVariant === 'CROSS_FLOW') {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)('confluence_selection_hydration_loom_button', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98cee705389562e0$export$2a0b2901b6f1e4ac), {
            description: intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription),
            entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
            placement: crossSellPopupPlacement,
            spotlightPlacement: crossSellSpotlightPlacement,
            sourceActionSubjectId: "createLoomHeaderItem",
            sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
            sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
            title: intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle),
            isCircle: isCircle,
            ariaLabel: intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            }),
            appearance: "subtle",
            immediateActivationCondition: isPulseActive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T0Pj.LoomCrossFlowPopupCard), {
            description: intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription),
            entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
            placement: crossSellPopupPlacement,
            spotlightPlacement: crossSellSpotlightPlacement,
            sourceActionSubjectId: "createLoomHeaderItem",
            sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
            sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
            title: intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    ...triggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel),
                    "data-vc": "loom-button",
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    ...ssrPlaceholderIdProp
                })))
        });
    }
    if (entryPointVariant === 'CROSS_JOIN') {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)('confluence_selection_hydration_loom_button', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98cee705389562e0$export$ba53a8d423873260), {
            description: intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription),
            placement: crossSellPopupPlacement,
            sourceActionSubjectId: "createLoomHeaderItem",
            title: intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle),
            entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
            isCircle: isCircle,
            ariaLabel: intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            }),
            appearance: "subtle",
            immediateActivationCondition: isPulseActive,
            flags: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? flags : undefined,
            sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
            description: intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription),
            placement: crossSellPopupPlacement,
            sourceActionSubjectId: "createLoomHeaderItem",
            title: intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle),
            entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
            triggerLink: (href, { onClick: onClick, ...otherTriggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    ...otherTriggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel),
                    "data-vc": "loom-button",
                    href: href,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    rel: "noreferrer",
                    target: "_blank",
                    onClick: onClick,
                    ...ssrPlaceholderIdProp
                }))),
            flags: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? flags : undefined,
            sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
        });
    } // This condition currently isn't possible, but explicitly handling it here in case the
    // logic defining `isEntryPointEnabled` changes without updating this rendering behavior
    return null;
};
const $981c6be93b35769c$export$35695746566a3d63 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
})((0, $7aRa9.withFlags)($981c6be93b35769c$var$PageHeaderLoomEntryPointComponent));
module.exports["PageHeaderLoomEntryPoint"] = $981c6be93b35769c$export$35695746566a3d63;

});

parcelRegister("2pBiX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");

const $e5ba90f4b97bd7c1$var$i18n = (0, $cgtv4.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = ({ flags: flags })=>{
    const intl = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("6T0Pj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $u9agA = parcelRequire("u9agA");


var $6NnCm = parcelRequire("6NnCm");


var $1cfhF = parcelRequire("1cfhF");

var $lfQiY = parcelRequire("lfQiY");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $jHpN3 = parcelRequire("jHpN3");


var $ej7WH = parcelRequire("ej7WH");


var $jkI1v = parcelRequire("jkI1v");


var $k0DFC = parcelRequire("k0DFC");


var $cnQgR = parcelRequire("cnQgR");

const $9bb41a4fe26f7df4$var$sourceAdType = 'crossFlow';
const $9bb41a4fe26f7df4$var$i18n = (0, $cgtv4.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $9bb41a4fe26f7df4$var$env = 'prod';
const $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID = (0, $1cfhF.FIRST_PARTY_CCP_PRODUCT_IDS)[$9bb41a4fe26f7df4$var$env].loom;
const $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource = (entrypointId)=>{
    switch(entrypointId){
        case 'loom-confluence-inline-comment':
            return 'loomConfluenceInlineCommentButton';
        case 'loom-confluence-page-editor-toolbar':
            return 'loomConfluencePageEditorToolbarButton';
        case 'loom-confluence-page-header':
            return 'loomConfluencePageHeaderButton';
        default:
            return null;
    }
};
const $9bb41a4fe26f7df4$export$7232e4c8af3c9680 = ({ description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, title: title, trigger: trigger, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $lfQiY.useFireCrossFlowAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const ctaRef = (0, $42omo.useRef)(null);
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)({
        sourceComponent: sourceComponent,
        sourceContext: sourceContext
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isInterestedInLoom: isInterestedInLoom, notInterestedInLoomCallback: notInterestedInLoomCallback } = (0, $k0DFC.useLoomAdControlState)({
        touchpoint: entryPointId
    });
    const { stopPostOffice: stopPostOffice } = (0, $jHpN3.useDiscoverabilityPulseActions)();
    const stopDiscoverabilityPulse = (0, $42omo.useCallback)(()=>{
        stopPostOffice();
    }, [
        stopPostOffice
    ]);
    // View event for go/BMD crossflow funnel
    (0, $42omo.useEffect)(()=>{
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'button',
            actionSubjectId: sourceComponent
        }, {
            source: entryPointId,
            recommendedProductIds: [
                $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            ]
        });
    }, [
        fireViewedUIEvent,
        sourceComponent,
        entryPointId
    ]);
    const onCrossFlowTriggerClick = (0, $42omo.useCallback)(async (triggerName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: triggerName,
                source: triggerName === 'tryNow' ? 'loomCrossFlowPopupCard' : sourceActionSubjectId,
                attributes: {
                    adType: $9bb41a4fe26f7df4$var$sourceAdType,
                    entrypoint: entryPointId
                }
            }
        }).fire();
        // Interaction event for go/BMD crossflow funnel. Only fire if entryPointId is registered in @atlassian/surface-analytics-specs package
        const crossFlowInteractionSource = $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource(entryPointId);
        crossFlowInteractionSource && fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: sourceContext
        }, {
            source: crossFlowInteractionSource,
            recommendedProductIds: [
                $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            ],
            targetProductId: $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
        });
        stopDiscoverabilityPulse();
        await triggerCrossFlow();
    }, [
        createAnalyticsEvent,
        entryPointId,
        triggerCrossFlow,
        sourceActionSubjectId,
        sourceContext,
        fireInteractedUIEvent,
        stopDiscoverabilityPulse
    ]);
    const handleNotInterested = (0, $42omo.useCallback)(async ()=>{
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'User not interested in Loom',
            attributes: {
                sourceComponent: entryPointId,
                adType: $9bb41a4fe26f7df4$var$sourceAdType
            }
        });
        stopDiscoverabilityPulse();
        await notInterestedInLoomCallback();
    }, [
        entryPointId,
        experienceTracker,
        notInterestedInLoomCallback,
        stopDiscoverabilityPulse
    ]);
    if (!isInterestedInLoom) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: ()=>onCrossFlowTriggerClick('tryNow'),
            ref: ctaRef
        }, intl.formatMessage($9bb41a4fe26f7df4$var$i18n.tryNow))),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                onClick: ()=>onCrossFlowTriggerClick(sourceActionSubjectId),
                onKeyDown: (e)=>{
                    if (e.key === 'Tab') ctaRef.current?.focus();
                }
            }),
        sourceAdType: $9bb41a4fe26f7df4$var$sourceAdType,
        spotlightPlacement: spotlightPlacement,
        primaryOnClick: ()=>onCrossFlowTriggerClick('tryNow'),
        adControl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId,
            customTrigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6NnCm.SpotlightShowMoreControl), {
                    testId: triggerProps.testId,
                    ref: triggerProps.triggerRef,
                    onClick: triggerProps.onClick
                })
        })
    });
};
module.exports["LoomCrossFlowPopupCard"] = $9bb41a4fe26f7df4$export$7232e4c8af3c9680;

});

parcelRegister("6NnCm", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9VJDA = parcelRequire("9VJDA");


var $fVUfS = parcelRequire("fVUfS");

const $ad0bfce27db989ea$var$styles = {
    root: "_2rko12b0 _1rjc12x7 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $ad0bfce27db989ea$export$b97a88aea1fe9a05 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: $ad0bfce27db989ea$var$styles.root,
        onClick: onClick,
        ref: ref,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: "Show more"
        })
    });
});
module.exports["SpotlightShowMoreControl"] = $ad0bfce27db989ea$export$b97a88aea1fe9a05;

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("ej7WH", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("2YerA");
var $fqrVl = parcelRequire("fqrVl");
var $jCM2u = parcelRequire("jCM2u");
parcelRequire("49sr4");
var $82BVR = parcelRequire("82BVR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $a763567c6da5be00$export$fa70eeb8352dd55e = ({ sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const crossFlow = (0, $jCM2u.useCrossFlow)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    return (0, $42omo.useCallback)(async ()=>{
        if (!crossFlow.isEnabled) {
            experienceTracker.fail({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                error: new Error('Loom crossflow is not enabled'),
                attributes: {
                    sourceComponent: sourceComponent,
                    adType: 'crossFlow'
                }
            });
            return;
        }
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: sourceComponent,
                adType: 'crossFlow'
            }
        });
        try {
            /**
			 * Additionally, if the user *does* go through cross-flow, they'll be navigated to Loom.com and
			 * not return to this code path.
			 */ await crossFlow.apiV1.open({
                journey: (0, $fqrVl.Journeys).GET_STARTED,
                sourceComponent: sourceComponent,
                sourceContext: sourceContext,
                targetProduct: (0, $82BVR.Targets).LOOM,
                v1: true
            });
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
            });
        }
    }, [
        crossFlow,
        sourceComponent,
        experienceTracker,
        sourceContext
    ]);
};
module.exports["useLoomCrossFlowRequestAccessCallback"] = $a763567c6da5be00$export$fa70eeb8352dd55e;

});

parcelRegister("2YerA", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("jCM2u")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("fqrVl")).Reasons);

var $jCM2u = parcelRequire("jCM2u");


var $fqrVl = parcelRequire("fqrVl");


});

parcelRegister("jCM2u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5xIym = parcelRequire("5xIym");


var $5B9n6 = parcelRequire("5B9n6");


var $fqrVl = parcelRequire("fqrVl");

const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $42omo.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $42omo.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $32c19fce160b377b$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $32c19fce160b377b$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $32c19fce160b377b$export$655b6c19a0daddb8;

});

parcelRegister("5xIym", function(module, exports) {
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $1eb0c594c750199f$export$9ff7368ac93fcf2d;

});

parcelRegister("5B9n6", function(module, exports) {
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $12de2f6721823415$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $12de2f6721823415$export$8fd5792fc468459f;

});

parcelRegister("fqrVl", function(module, exports) {
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $4db9b154d66dd01a$export$3411873bfd520bb6;
module.exports["Reasons"] = $4db9b154d66dd01a$export$da2d4f2f250d6f84;

});

parcelRegister("49sr4", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("ctMWd")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("82BVR")).Targets);

var $ctMWd = parcelRequire("ctMWd");


var $82BVR = parcelRequire("82BVR");


});

parcelRegister("ctMWd", function(module, exports) {
class $0081b4f618dff6fe$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $0081b4f618dff6fe$export$a5e53d1dcbd6eb61;

});

parcelRegister("82BVR", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $49d7ae8ec7eae7d8$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $49d7ae8ec7eae7d8$export$59a8eb9cff113544;

});

parcelRegister("jkI1v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $9VJDA = parcelRequire("9VJDA");


var $irxfF = parcelRequire("irxfF");

var $2zUpm = parcelRequire("2zUpm");

var $3ylo6 = parcelRequire("3ylo6");

var $hEz36 = parcelRequire("hEz36");


var $6mKj3 = parcelRequire("6mKj3");

const $8b615b773eb5cff4$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $8b615b773eb5cff4$export$81624a1cb6914931 = (0, $cgtv4.defineMessages)({
    dismissFlagTitle: {
        id: "loom-utils.loom-ad-control.dismiss-flag-title",
        defaultMessage: "Got it, thanks for letting us know"
    },
    dismissFlagDescription: {
        id: "loom-utils.loom-ad-control.dismiss-flag-description",
        defaultMessage: "You won\u2019t see this here as often."
    },
    reasonsModalTitle: {
        id: "loom-utils.loom-ad-control.reasons-modal-title",
        defaultMessage: "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        id: "loom-utils.loom-ad-control.reasons-modal-explanation",
        defaultMessage: "We think that <strong>Loom</strong> will improve your team\u2019s productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        id: "loom-utils.loom-ad-control.reasons-modal-bullet-one",
        defaultMessage: "the size of your team"
    },
    reasonsModalBulletTwo: {
        id: "loom-utils.loom-ad-control.reasons-modal-bullet-two",
        defaultMessage: "your existing Atlassian products"
    },
    privacyPolicy: {
        id: "loom-utils.loom-ad-control.privacy-policy",
        defaultMessage: "Learn more about your data privacy with Atlassian"
    }
});
const $8b615b773eb5cff4$var$linkStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $8b615b773eb5cff4$var$moreIconStyles = (0, $ecnYn.xcss)({
    alignSelf: 'center'
});
const $8b615b773eb5cff4$var$LoomAdControlReasonModalBody = ({ entryPointId: entryPointId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'loomAdControlReasonsModal',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: entryPointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalExplanation, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8b615b773eb5cff4$var$linkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        href: $8b615b773eb5cff4$export$aefe1c8741b24a28,
        target: "_blank"
    }, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.privacyPolicy))));
};
const $8b615b773eb5cff4$export$5922fd76035890d5 = ({ onDismiss: onDismiss, entryPointId: entryPointId, spacing: spacing = 'compact', customTrigger: customTrigger })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2zUpm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irxfF.default), {
        itemId: "loom-ad-controls",
        trigger: ({ triggerRef: triggerRef, ...props })=>customTrigger ? customTrigger({
                testId: 'loom-utils.loom-ad-control.custom-button',
                triggerRef: triggerRef,
                onClick: props.onClick
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8b615b773eb5cff4$var$moreIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                onClick: (e)=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'toggleLoomAdControlDropdown',
                            source: 'loomCrossFlowPopupCard',
                            attributes: {
                                adType: 'crossFlow',
                                entrypoint: entryPointId
                            }
                        }
                    }).fire();
                    props.onClick?.(e);
                },
                appearance: "subtle",
                spacing: spacing,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                label: "LoomAdControl",
                testId: "loom-utils.loom-ad-control.button"
            })),
        ...(0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false) ? {
            strategy: 'absolute'
        } : {}
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ylo6.default), {
            ...props,
            flagProps: {
                title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagTitle),
                description: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagDescription)
            },
            onClick: onDismiss
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEz36.default), {
            ...props,
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'toggleLoomAdControlReasonsModal',
                        source: 'loomAdControlDropdown',
                        attributes: {
                            adType: 'crossFlow',
                            entrypoint: entryPointId
                        }
                    }
                }).fire();
            },
            modalProps: {
                title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8b615b773eb5cff4$var$LoomAdControlReasonModalBody, {
                    entryPointId: entryPointId
                })
            }
        }))));
};
module.exports["LoomAdControl"] = $8b615b773eb5cff4$export$5922fd76035890d5;

});

parcelRegister("k0DFC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $66b8bcdb334754ff$var$getCachedValuesArray = ()=>{
    try {
        const cachedValues = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED);
        if (cachedValues !== null && cachedValues !== 'undefined') return String(cachedValues).split(',');
    } catch (e) {} // Swallow any errors and return empty array
    return [];
};
const $66b8bcdb334754ff$export$83d1e1540840fcd3 = ({ touchpoint: touchpoint })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const valueToBeCached = `${touchpoint}.${userId}.${cloudId}`;
    const cachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
    const [isInterestedInLoom, setIsInterestedInLoom] = (0, $42omo.useState)(!cachedValuesArray || !cachedValuesArray.includes(valueToBeCached));
    const notInterestedInLoomCallback = (0, $42omo.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'notInterested',
                source: 'loomAdControlDropdown',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: touchpoint
                }
            }
        }).fire();
        // Avoid duplicate values being added to cache
        if (!isInterestedInLoom) return;
        // Ensure fresh cache values array by reading from storage
        const freshCachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
        freshCachedValuesArray.push(valueToBeCached);
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED, freshCachedValuesArray);
        setIsInterestedInLoom(false);
    }, [
        isInterestedInLoom,
        valueToBeCached,
        createAnalyticsEvent,
        touchpoint
    ]);
    return {
        isInterestedInLoom: isInterestedInLoom,
        notInterestedInLoomCallback: notInterestedInLoomCallback
    };
};
module.exports["useLoomAdControlState"] = $66b8bcdb334754ff$export$83d1e1540840fcd3;

});

parcelRegister("jFlST", function(module, exports) {

let $e512d27290c4b297$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e512d27290c4b297$var$load("2DxXe").then(()=>parcelRequire('9cwPn'));

});

parcelRegister("2ucFg", function(module, exports) {

let $1cf8350b92d2cf84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1cf8350b92d2cf84$var$load("EYiM3").then(()=>parcelRequire('lvs3G'));

});

parcelRegister("5i3ci", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1lhEF = parcelRequire("1lhEF");


var $ma85v = parcelRequire("ma85v");

const $9fbe62170cacfcf3$export$d6e697640576fe29 = ({ children: children, entryPointId: entryPointId, isCircle: isCircle })=>{
    const { isPulseActive: isPulseActive } = (0, $ma85v.useDiscoverabilityPulsePostOffice)(entryPointId);
    if (!isPulseActive) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
        radius: isCircle ? 24 : 3,
        testId: "loom-cross-sell-discoverability-pulse"
    }, children);
};
module.exports["DiscoverabilityPulse"] = $9fbe62170cacfcf3$export$d6e697640576fe29;

});

parcelRegister("ma85v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXjWU = parcelRequire("aXjWU");


var $jHpN3 = parcelRequire("jHpN3");

const $486bcfa61be9017c$var$PULSE_MESSAGE_IDS = [
    'cc-loom-x-sell-discoverability-pulse-1',
    'cc-loom-x-sell-discoverability-pulse-2',
    'cc-loom-x-sell-discoverability-pulse-3',
    'cc-loom-x-sell-discoverability-pulse-4',
    'cc-loom-x-sell-discoverability-pulse-5'
];
const $486bcfa61be9017c$var$TIMEOUT_MS = 300;
const $486bcfa61be9017c$var$LAST_PULSE_INDEX = $486bcfa61be9017c$var$PULSE_MESSAGE_IDS.length - 1;
const $486bcfa61be9017c$var$requestNextPulse = (nextIndex, pulseHooks, hasRequestedRef, lastRequestedRef)=>{
    if (nextIndex < pulseHooks.length && !hasRequestedRef.current.has(nextIndex)) {
        hasRequestedRef.current.add(nextIndex);
        lastRequestedRef.current = {
            index: nextIndex,
            timestamp: Date.now()
        };
        pulseHooks[nextIndex].requestMessageStart();
    }
};
const $486bcfa61be9017c$export$c4b0090b21b70d1d = (entryPointId)=>{
    // All hooks must be called unconditionally (Rules of Hooks)
    const isPulseActive = (0, $jHpN3.useIsPulseActive)(entryPointId);
    const { start: startPulse } = (0, $jHpN3.useDiscoverabilityPulseActions)();
    const skipRefreshPulseStatus = isPulseActive && (0, $jHpN3.havePulsesEnded)();
    // Call hooks at the top level for all message IDs
    const pulse1 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($486bcfa61be9017c$var$PULSE_MESSAGE_IDS[4]);
    const pulseHooks = (0, $42omo.useMemo)(()=>[
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ], [
        pulse1,
        pulse2,
        pulse3,
        pulse4,
        pulse5
    ]);
    // Track which messages we've requested to avoid duplicate requests
    const hasRequestedRef = (0, $42omo.useRef)(new Set());
    // Track the last requested message index and when it was requested (for timeout)
    const lastRequestedRef = (0, $42omo.useRef)(null);
    // Track which message index was last started (to detect dismissal)
    const lastStartedIndexRef = (0, $42omo.useRef)(null);
    // State trigger to force re-evaluation when timeout expires
    const [timeoutTrigger, setTimeoutTrigger] = (0, $42omo.useState)(0);
    // Request messages sequentially - only request the next one if previous ones haven't started
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Find the first message that hasn't started and request it
        // If a previous message has started, we stop (handled by the other effect)
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            // If this message has started, we're done - don't request any more
            if (pulseHook.hasMessageStarted) {
                // Clear the timeout tracking since we found an active message
                lastRequestedRef.current = null;
                // Track which message is started (will be set by the activation effect, but set here too for consistency)
                lastStartedIndexRef.current = i;
                break;
            }
            // If we haven't requested this one yet, request it and stop
            // The effect will re-run when hasMessageStarted changes, allowing us to move to the next one
            if (!hasRequestedRef.current.has(i)) {
                hasRequestedRef.current.add(i);
                lastRequestedRef.current = {
                    index: i,
                    timestamp: Date.now()
                };
                pulseHook.requestMessageStart();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted,
        pulse1.requestMessageStart,
        pulse2.requestMessageStart,
        pulse3.requestMessageStart,
        pulse4.requestMessageStart,
        pulse5.requestMessageStart,
        pulse1.handlePostOfficeClickTracking,
        pulse2.handlePostOfficeClickTracking,
        pulse3.handlePostOfficeClickTracking,
        pulse4.handlePostOfficeClickTracking,
        pulse5.handlePostOfficeClickTracking
    ]);
    // Timeout handler: if a requested message hasn't started after a delay, try the next one
    // Note: If a message was already dismissed, Post Office filters it before page load
    // so we only need time for the initial load and state updates (~200-300ms)
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
        const { index: index, timestamp: timestamp } = lastRequestedRef.current;
        const pulseHook = pulseHooks[index];
        // If the message has started, clear the timeout tracking
        if (pulseHook.hasMessageStarted) {
            lastRequestedRef.current = null;
            return;
        }
        // If enough time has passed and the message still hasn't started, move to the next one
        const elapsed = Date.now() - timestamp;
        if (elapsed >= $486bcfa61be9017c$var$TIMEOUT_MS) {
            // Clear the current request tracking
            lastRequestedRef.current = null;
            // Try the next message if available
            $486bcfa61be9017c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        } else {
            // Set a timeout to trigger re-evaluation when the timeout period elapses
            const remainingTime = $486bcfa61be9017c$var$TIMEOUT_MS - elapsed;
            const timeoutId = setTimeout(()=>{
                setTimeoutTrigger((prev)=>prev + 1);
            }, remainingTime);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        timeoutTrigger,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Reactively respond when a message starts - activate the pulse
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Check each pulse in sequence - activate the first one that has started
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            const messageId = $486bcfa61be9017c$var$PULSE_MESSAGE_IDS[i];
            if (pulseHook.hasMessageStarted) {
                lastStartedIndexRef.current = i;
                startPulse(entryPointId, messageId, {
                    onDismiss: ()=>pulseHook.dismissMessage(),
                    onClick: ()=>pulseHook.handlePostOfficeClickTracking?.()
                });
                // If this is the last pulse, mark pulses as ended
                if (i === $486bcfa61be9017c$var$LAST_PULSE_INDEX) /**
					 * Mark the EP message as "complete" and disable Loom discoverability in localStorage
					 * immediately after showing the final pulse. Otherwise, if a user ignores the entrypoints
					 * entirely and never clicks on one while it's pulsing, they'll:
					 *
					 * - Remain in the TAP audience forever
					 * - Continue to check the EP messages every time an entrypoint renders
					 *
					 * This will technically unlock EP to show other messages, but the pulse is subtle enough that
					 * this shouldn't result in poor UX
					 */ (0, $jHpN3.endPulses)();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        entryPointId,
        startPulse,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Handle message dismissal: if a started message becomes not started, request the next one
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
        const startedIndex = lastStartedIndexRef.current;
        const startedPulseHook = pulseHooks[startedIndex];
        // If the message that was started is no longer started, it was dismissed
        if (!startedPulseHook.hasMessageStarted) {
            // Clear the tracking for this message so we can move forward
            hasRequestedRef.current.delete(startedIndex);
            lastStartedIndexRef.current = null;
            // Request the next message if available
            $486bcfa61be9017c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    return {
        isPulseActive: isPulseActive
    };
};
module.exports["useDiscoverabilityPulsePostOffice"] = $486bcfa61be9017c$export$c4b0090b21b70d1d;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("luv00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("hQYP3", function(module, exports) {
module.exports = new URL("pageHeaderSpotlightImage.b1e98e59.png", import.meta.url).toString();

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("ikPi2", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2748374594b3931f$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        fullPageEditorLoomUrl: undefined,
        pageCommentEditorLoomUrl: undefined,
        inlineCommentEditorLoomUrl: undefined
    },
    actions: {
        updateFullPageEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    fullPageEditorLoomUrl: video
                });
            },
        updatePageCommentEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    pageCommentEditorLoomUrl: video
                });
            }
    },
    name: 'loomUrlToInsert'
});
const $2748374594b3931f$export$f76207310d699374 = (0, $9zUhf.createHook)($2748374594b3931f$var$Store);
const $2748374594b3931f$export$b51bf851d750866c = ()=>$2748374594b3931f$export$f76207310d699374()[1];
module.exports["useLoomInsertUrlState"] = $2748374594b3931f$export$f76207310d699374;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("k7Tf7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2xusd = parcelRequire("2xusd");


var $2MPqq = parcelRequire("2MPqq");

const $94cea1b432ccea5e$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2MPqq.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2xusd.Manager), {
            children: children
        })
    });
};
module.exports["PopoverProvider"] = $94cea1b432ccea5e$export$bf694c7c431c162a;

});

parcelRegister("a90ar", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cs0ez = parcelRequire("cs0ez");

const $fcb2cc293f5cb422$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};
module.exports["PopoverTarget"] = $fcb2cc293f5cb422$export$5ad0c0856b469f13;

});

parcelRegister("3chlW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $497b092596857daa$var$styles = {
    root: "_1bsb1osq"
};
const $497b092596857daa$export$205c28213090dc52 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $497b092596857daa$var$styles.root,
        role: "group",
        justifyContent: "end",
        gap: "space.050",
        children: children
    });
});
module.exports["SpotlightActions"] = $497b092596857daa$export$205c28213090dc52;

});

parcelRegister("f1UQW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $8f17e6224eab722b$var$styles = {
    root: "_18zrpxbi _syaz15cr _1q51u2gc"
};
const $8f17e6224eab722b$export$4ae665cf62a00c3f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: ref,
        xcss: $8f17e6224eab722b$var$styles.root,
        testId: testId,
        children: children
    });
});
module.exports["SpotlightBody"] = $8f17e6224eab722b$export$4ae665cf62a00c3f;

});

parcelRegister("71521", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $2MPqq = parcelRequire("2MPqq");


var $jEGan = parcelRequire("jEGan");

const $632f68eebac3d948$var$styles = {
    root: "_kqswh2mm",
    card: "_2rko1mok _zulpu2gc _kqswstnw _1bsbaq3k _1q51u2gc _85i5utpp _1e0c1txw _2lx21bp4 _16qs1nax"
};
const $632f68eebac3d948$var$placementStyles = {
    'top-start': "_u7co12x7 _rjxpc7mi",
    'top-center': "_u7co12x7 _1e021qz4",
    'top-end': "_u7co12x7 _1e02c7mi",
    'right-start': "_1e0212x7 _u7comgjw",
    'right-end': "_1e0212x7 _152tmgjw",
    'bottom-start': "_152t12x7 _rjxpc7mi",
    'bottom-center': "_152t12x7 _1e021qz4",
    'bottom-end': "_152t12x7 _1e02c7mi",
    'left-start': "_rjxp12x7 _u7comgjw",
    'left-end': "_rjxp12x7 _152tmgjw"
};
const $632f68eebac3d948$export$14710e13fc01d383 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const cardRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            $632f68eebac3d948$var$styles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jEGan.Caret), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: (0, $1Whri.cx)($632f68eebac3d948$var$styles.card, $632f68eebac3d948$var$placementStyles[card.placement]),
                children: children
            })
        ]
    });
});
module.exports["SpotlightCard"] = $632f68eebac3d948$export$14710e13fc01d383;

});

parcelRegister("jEGan", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $2MPqq = parcelRequire("2MPqq");

const $8ca37cde5226694e$var$styles = {
    root: "_bfhk1aqn _mkrzmhja _4t3io7ao _kqswh2mm _1bsbo7ao _1pby1fw0",
    'top-start': "_t9ec71a3",
    'top-center': "_t9ec71a3",
    'top-end': "_t9ec71a3",
    'bottom-start': "_t9ec1hke",
    'bottom-center': "_t9ec1hke",
    'bottom-end': "_t9ec1hke",
    'right-start': "_t9ecjyd4",
    'right-end': "_t9ecjyd4",
    'left-start': "_t9ecebzf",
    'left-end': "_t9ecebzf"
};
const $8ca37cde5226694e$export$88fca06e22f21720 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId }, ref)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $gMc0m.default)([
            $8ca37cde5226694e$var$styles.root,
            $8ca37cde5226694e$var$styles[card.placement]
        ])
    });
});
module.exports["Caret"] = $8ca37cde5226694e$export$88fca06e22f21720;

});

parcelRegister("eopLP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $c18394162d9dc107$var$styles = {
    root: "_bozgpxbi _y4tiutpp _1bsb1osq"
};
const $c18394162d9dc107$export$f76dbc85ba76ccc2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $c18394162d9dc107$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        children: children
    });
});
module.exports["SpotlightFooter"] = $c18394162d9dc107$export$f76dbc85ba76ccc2;

});

parcelRegister("aZQ5F", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $ad24be9a70db7ad2$var$styles = {
    root: "_bozgpxbi _y4tiutpp"
};
const $ad24be9a70db7ad2$export$d646029b3ba8ab76 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $ad24be9a70db7ad2$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100",
        children: children
    });
});
module.exports["SpotlightHeader"] = $ad24be9a70db7ad2$export$d646029b3ba8ab76;

});

parcelRegister("bUJpY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $2MPqq = parcelRequire("2MPqq");

const $7a1f3efc02714981$export$b57275b1b6b9863b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { heading: heading } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
        id: heading.id,
        ref: ref,
        testId: testId,
        size: "xsmall",
        children: children
    });
});
module.exports["SpotlightHeadline"] = $7a1f3efc02714981$export$b57275b1b6b9863b;

});

parcelRegister("fNcP1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $2MPqq = parcelRequire("2MPqq");

const $456a9b1f10f70d47$var$styles = {
    root: "_2rko12b0 _1dqonqa1 _189ee4h9 _1h6d8yml _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $456a9b1f10f70d47$export$eea27caf91a85655 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { primaryAction: primaryAction } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const done = (event)=>{
        primaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $456a9b1f10f70d47$var$styles.root,
        onClick: onClick || done,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    });
});
module.exports["SpotlightPrimaryAction"] = $456a9b1f10f70d47$export$eea27caf91a85655;

});

parcelRegister("aVS0S", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $b2d7675e2e3d4813$var$styles = {
    root: "_zulpu2gc _1e0c1txw _2lx21sbv"
};
const $b2d7675e2e3d4813$export$67fb68d4ebe55a86 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        role: "group",
        className: (0, $gMc0m.default)([
            $b2d7675e2e3d4813$var$styles.root
        ]),
        children: children
    });
});
module.exports["SpotlightControls"] = $b2d7675e2e3d4813$export$67fb68d4ebe55a86;

});

parcelRegister("2owmo", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $2MPqq = parcelRequire("2MPqq");

const $e90e33f81b492555$var$styles = {
    root: "_2rko12b0 _1rjc12x7 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27",
    rootT26Shape: "_2rko1qi0"
};
const $e90e33f81b492555$export$4eef19754b0d485e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ autoFocus: autoFocus = true, onClick: onClick, testId: testId }, ref)=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const dismiss = (event)=>{
        popoverContent.dismiss.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        autoFocus: autoFocus,
        onClick: onClick || dismiss,
        ref: ref,
        testId: testId,
        xcss: (0, $1Whri.cx)($e90e33f81b492555$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $e90e33f81b492555$var$styles.rootT26Shape),
        "aria-label": "Dismiss",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: "Close"
        })
    });
});
module.exports["SpotlightDismissControl"] = $e90e33f81b492555$export$4eef19754b0d485e;

});

parcelRegister("fdtRy", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $5df9daaf2c005ad4$var$styles = {
    root: "_1reo15vq _18m915vq _1bsbaq3k _4t3ihcro"
};
const $5df9daaf2c005ad4$export$cf33151c3f01cd9a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: ref,
        xcss: $5df9daaf2c005ad4$var$styles.root,
        testId: testId,
        children: children
    });
});
module.exports["SpotlightMedia"] = $5df9daaf2c005ad4$export$cf33151c3f01cd9a;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("7DBey", function(module, exports) {
const $91acf6157f8b5c3c$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $91acf6157f8b5c3c$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $91acf6157f8b5c3c$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};
module.exports["isServiceWithDeps"] = $91acf6157f8b5c3c$export$4094c5185600bd73;
module.exports["unimplementedAbstractService"] = $91acf6157f8b5c3c$export$6e9f7b680f09bab1;
module.exports["toError"] = $91acf6157f8b5c3c$export$cc3b967c039ed3e7;

});

parcelRegister("2Q94g", function(module, exports) {
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $dh538 = parcelRequire("dh538");


var $7DBey = parcelRequire("7DBey");

const $26f4407bbf6764a3$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $26f4407bbf6764a3$export$ddb1688281a3443e = (0, $7DBey.unimplementedAbstractService)('getCurrentCloudId');
const $26f4407bbf6764a3$export$5ebc6cb2748e1881 = (0, $7DBey.unimplementedAbstractService)('getCurrentUserId');
const $26f4407bbf6764a3$export$d01408ed6f850a64 = (0, $7DBey.unimplementedAbstractService)('getCurrentProduct');
const $26f4407bbf6764a3$export$a48841c0475a8073 = (0, $7DBey.unimplementedAbstractService)('createAnalyticsEvent');
const $26f4407bbf6764a3$export$a27c21aa3ed8f0f1 = (0, $7DBey.unimplementedAbstractService)('fireErrorAnalytics');
class $26f4407bbf6764a3$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $26f4407bbf6764a3$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: // Trying to get the status code (404, 500 etc.) from multiple properties
        // because Expansion Services can be used in different environments,
        // which may dependency-inject different fetchJSON() implementations.
        // These throw different FetchError shapes across the main products.
        // Because we're dealing with exceptions, this is not guarded by types.
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $dh538.fg)('puma-1321-expansion-services-event-error-status') && err ? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'responseCode') ?? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'statusCode') ?? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'status') : err instanceof $26f4407bbf6764a3$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });
const $26f4407bbf6764a3$var$getErrorStatusProperty = (error, key)=>{
    const value = error[key];
    if (typeof value === 'number') return value;
};
const $26f4407bbf6764a3$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $26f4407bbf6764a3$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $26f4407bbf6764a3$export$1f2663aaa83f036d = 'Failed to fetch';
const $26f4407bbf6764a3$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $26f4407bbf6764a3$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $26f4407bbf6764a3$export$6827a0909c1bf12f = [
    $26f4407bbf6764a3$export$1f2663aaa83f036d,
    $26f4407bbf6764a3$export$65e55894e6e38a89,
    $26f4407bbf6764a3$export$f25400ad927aa79c
];
const $26f4407bbf6764a3$export$e1b6bb1617649e83 = (errorMessage)=>$26f4407bbf6764a3$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $26f4407bbf6764a3$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $26f4407bbf6764a3$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $26f4407bbf6764a3$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $26f4407bbf6764a3$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $26f4407bbf6764a3$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $26f4407bbf6764a3$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $26f4407bbf6764a3$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $26f4407bbf6764a3$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $26f4407bbf6764a3$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (e) {
        return false;
    }
};
const $26f4407bbf6764a3$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $26f4407bbf6764a3$export$80a3c1a1eb6f063 || errorMessage === $26f4407bbf6764a3$export$e089e1d2018847da;
const $26f4407bbf6764a3$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $26f4407bbf6764a3$export$678d91a98f79a24d(message, status) || status === 400 && ($26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$c53f16dd5442ef61) || $26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$e27975535396141b)) || status === 412 && $26f4407bbf6764a3$export$395f41a02d6a8be0(key, message);
};
const $26f4407bbf6764a3$export$9de493bcd9b1d977 = 'bad-request';
const $26f4407bbf6764a3$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $26f4407bbf6764a3$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $26f4407bbf6764a3$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $26f4407bbf6764a3$export$e5254cb9f7678ab9) return false;
    return true;
};
module.exports["getStargateURL"] = $26f4407bbf6764a3$export$c7904a8284e43beb;
module.exports["getCurrentCloudId"] = $26f4407bbf6764a3$export$ddb1688281a3443e;
module.exports["getCurrentUserId"] = $26f4407bbf6764a3$export$5ebc6cb2748e1881;
module.exports["getCurrentProduct"] = $26f4407bbf6764a3$export$d01408ed6f850a64;
module.exports["createAnalyticsEvent"] = $26f4407bbf6764a3$export$a48841c0475a8073;
module.exports["getErrorDetails"] = $26f4407bbf6764a3$export$33e83b6fee5d732d;
module.exports["isAcceptableFailure"] = $26f4407bbf6764a3$export$678d91a98f79a24d;
module.exports["isAcceptableFailureForUserInvite"] = $26f4407bbf6764a3$export$1c4c1f7e2d529330;
module.exports["shouldReportFailedInvite"] = $26f4407bbf6764a3$export$90cda429f609d666;

});

parcelRegister("bmTr3", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

const $c1aca408fa9ca14a$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $7DBey.unimplementedAbstractService)('fetchJSON');
module.exports["fetchJSON"] = $c1aca408fa9ca14a$export$81bec6e38e8b706b;

});

parcelRegister("hCOLa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jdJm1 = parcelRequire("jdJm1");

const $5c38ed4eae58ec94$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $42omo.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$5c38ed4eae58ec94$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $jdJm1.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $5c38ed4eae58ec94$var$DIFFERENT = false;
const $5c38ed4eae58ec94$var$EQUAL = true;
const $5c38ed4eae58ec94$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $5c38ed4eae58ec94$var$EQUAL;
    if (!prevObject || !nextObject) return $5c38ed4eae58ec94$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $5c38ed4eae58ec94$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $5c38ed4eae58ec94$var$DIFFERENT;
        }
        return $5c38ed4eae58ec94$var$EQUAL;
    }
};
module.exports["useService"] = $5c38ed4eae58ec94$export$6de4685a6c88b4e9;

});

parcelRegister("jdJm1", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

function $e28c424ef32ed9ff$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $7DBey.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $e28c424ef32ed9ff$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }
module.exports["resolveService"] = $e28c424ef32ed9ff$export$388f24d19a29b0a2;

});


//# sourceMappingURL=PageHeaderLoomEntryPoint.41774b15.js.map
